import {html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {repeat} from 'lit/directives/repeat.js';
import {when} from 'lit/directives/when.js';
import {classMap} from 'lit/directives/class-map.js';

import {FeatureSelect} from './featureSelect';

import radio from '../../../icons/radio';

@customElement('feature-reduced-list-select')
export class FeatureReducedListSelect extends FeatureSelect {

	static styles = [
		FeatureSelect.styles,
		css`
		  :host {
		  }

		  .title {
			display: flex;
			align-items: center;
			font-family: var(--font-family-light);
			font-size: var(--font-size-widget);
			color: var(--color-text-widget-title);
			height: var(--height-title);
		  }

		  .values {
			display: flex;
			flex-direction: column;
		  }
		  .values.notSatisfied {
			border: none;
		  }

		  .icon {
			width: 11px;
			height: 11px;
			padding: 5px;
			display: inline-block;
		  }

		  .icon svg {
			display: block;
			fill: currentColor
		  }

		  .satisfied {
			color: var(--color-text-widget-title);
		  }

		  .icon.satisfied {
			color: var(--color-grey5);
		  }

		  .notSatisfied {
			color: var(--color-warn);
		  }
		`];

	render() {
		return html`
			<div>
				<div class="title">
					${when(this.isSatisfied(), () => html`
						<span class="icon satisfied">${radio}</span>
					`, () => html`
						<span class="icon notSatisfied">${radio}</span>
					`)}
					<trans-label
							key="${this.feature.variableId}"
							context="F"
							title="${this.feature.variableId}">
					</trans-label>
					${when(this.hasFeatureDescription(), () => html`
						<button class="info" @click="${this.openModal}">
							Info
						</button>
					`)}
				</div>
				<div class="values ${classMap({highlight: this.isHighlight(), notSatisfied: !this.isSatisfied()})}">
					${repeat([...this.feature.values]
									// filter(value => !value.disabled)
									.sort((a, b) => this.getProductData(a.featureValueId)?.displaySequenceUi - this.getProductData(b.featureValueId)?.displaySequenceUi),
							(featureValue) => featureValue.featureValueId,
							(featureValue) => html`
								<feature-reduced-list-select-item .feature=${this.feature}
																  .hideDisabled=${this.hideDisabled}
														  .featureValue=${featureValue}
														  .productData=${this.getProductData(featureValue.featureValueId)}>
								</feature-reduced-list-select-item>
							`)}
				</div>
			</div>

		`;
	}
}
